const triggerIntercomWidget = () => {
    const appId = "w0dhcqh1";

    window.intercomSettings = {
        app_id: appId,
        custom_launcher_selector:'#btn-chat-with-us'
    };
}

$(triggerIntercomWidget())